import gql from 'graphql-tag';

const GET_TICKET_CONVERSATIONS = gql`
  query getTicketConversations($ticketId: ID!) {
    getTicketConversations(ticketId: $ticketId) {
      conversationId
      content
      time
      user {
        userId
        firstName
        lastName
      }
      attachments {
        fileName
        originalFileName
        fileSize
      }
    }
  }
`;

const GET_CONVERSATION_FROM_TEMPLATE = gql`
  mutation($ticketId: ID!, $templateId: ID!) {
    prepareConversationFromReplyTemplate(
      ticketId: $ticketId
      templateId: $templateId
    ) {
      content
    }
  }
`;

const GET_CLIENT_CONVERSATION_REPLY_RECIPEINTS = gql`
  query getClientConversationReplyRecipients(
    $conversationInput: ConversationIdentifierInput!
  ) {
    getClientConversationReplyRecipients(input: $conversationInput) {
      to {
        userId
        name
        email
      }
      cc {
        userId
        name
        email
      }
      selectedMailbox {
        boxId
        outgoingAddress
      }
      mailboxes {
        boxId
        outgoingAddress
      }
    }
  }
`;

export {
  GET_TICKET_CONVERSATIONS,
  GET_CONVERSATION_FROM_TEMPLATE,
  GET_CLIENT_CONVERSATION_REPLY_RECIPEINTS
};
